import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class CampaignMemberService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignMembers')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-user-tag';
    }
}
